module.exports = __webpack_public_path__ + "static/media/48388822_2308778359197342_8401191244859965440_o-thumb.026a04b9.jpg";